module.exports = __webpack_public_path__ + "media/images/flags/na-ea7d7cda2f2d3255792dcc1153627087.svg";